import { TFunction } from 'i18next';
import moment from 'moment';

export const formatMessageTime = (dateTime: Date, t: TFunction): string => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const messageDate = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
  const timePart = moment(dateTime).format('HH:mm');

  if (messageDate.getTime() === today.getTime()) {
    return timePart;
  }

  if (messageDate.getTime() === yesterday.getTime()) {
    return `${t('yesterday')} ${timePart}`;
  }

  const daysDiff = Math.floor((now.getTime() - dateTime.getTime()) / (1000 * 60 * 60 * 24));
  if (daysDiff < 7) {
    const dayOfWeek = getDayOfWeek(dateTime.getDay(), t);

    return `${dayOfWeek} ${timePart}`;
  }

  if (now.getFullYear() === dateTime.getFullYear()) {
    const monthName = getMonthName(dateTime.getMonth(), t);

    return `${dateTime.getDate()} ${monthName} ${timePart}`;
  }

  const monthName = getMonthName(dateTime.getMonth(), t);

  return `${dateTime.getDate()} ${monthName} ${dateTime.getFullYear()} ${timePart}`;
};

export const formatDateSeparator = (dateTime: Date, t: TFunction): string => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const messageDate = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());

  if (messageDate.getTime() === today.getTime()) {
    return t('today');
  }

  if (messageDate.getTime() === yesterday.getTime()) {
    return t('yesterday');
  }

  const daysDiff = Math.floor((now.getTime() - dateTime.getTime()) / (1000 * 60 * 60 * 24));
  if (daysDiff < 7) {
    const dayOfWeek = getDayOfWeek(dateTime.getDay(), t);

    return dayOfWeek;
  }

  if (now.getFullYear() === dateTime.getFullYear()) {
    const monthName = getMonthName(dateTime.getMonth(), t);

    return `${dateTime.getDate()} ${monthName}`;
  }

  const monthName = getMonthName(dateTime.getMonth(), t);

  return `${dateTime.getDate()} ${monthName} ${dateTime.getFullYear()}`;
};

export const isSameDay = (date1: Date, date2: Date): boolean => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

const getDayOfWeek = (weekday: number, t: TFunction): string => {
  switch (weekday) {
    case 1:
      return t('mondayShort');
    case 2:
      return t('tuesdayShort');
    case 3:
      return t('wednesdayShort');
    case 4:
      return t('thursdayShort');
    case 5:
      return t('fridayShort');
    case 6:
      return t('saturdayShort');
    case 0:
      return t('sundayShort');
    default:
      return '';
  }
};

const getMonthName = (month: number, t: TFunction): string => {
  switch (month) {
    case 0:
      return t('januaryGenitive');
    case 1:
      return t('februaryGenitive');
    case 2:
      return t('marchGenitive');
    case 3:
      return t('aprilGenitive');
    case 4:
      return t('mayGenitive');
    case 5:
      return t('juneGenitive');
    case 6:
      return t('julyGenitive');
    case 7:
      return t('augustGenitive');
    case 8:
      return t('septemberGenitive');
    case 9:
      return t('octoberGenitive');
    case 10:
      return t('novemberGenitive');
    case 11:
      return t('decemberGenitive');
    default:
      return '';
  }
};
